import frenchMessagesUI from 'ra-language-french';
import frenchMessages from './translations/fr';

const messages = {
  fr: {...frenchMessages, ...frenchMessagesUI},
};

export const i18nProvider = locale => messages[locale];
